import type { AccessCatalog } from "types/interfaces/access";
import PermissionsPanel from "./PermissionsPanel";
import {
  clientGrantedLines,
  clientNoAccessNames,
  type ClientSwitchState,
} from "./clientPanelModel";

interface Props {
  catalog: AccessCatalog;
  state: ClientSwitchState;
  title?: string;
  subHeader?: string;
}

/** What a client user's switches open, rendered from the catalog copy. */
export default function ClientAccessPanel({
  catalog,
  state,
  title = "Permissions Granted",
  subHeader,
}: Props) {
  return (
    <PermissionsPanel
      title={title}
      subHeader={subHeader}
      granted={clientGrantedLines(catalog, state)}
      missing={clientNoAccessNames(catalog, state)}
    />
  );
}
